import React from 'react';
import { Grid, Row, Col, Table } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { getThumbFileFromEntity } from 'helpers/items';
import OrderTimelineContent from 'components/layout/order/OrderTimelineContent';
import { forEach as _forEach } from 'lodash';
import {intlModule} from "@chedri/base";
import {connect, useSelector} from "react-redux";
import {getNameInCurrentLanguage} from "helpers/intl";
import {withRouter} from "react-router-dom";

class OrderInfo extends React.Component {
  getServiceName = service => {
    const messages = this.props.intl.messages;

    switch (service.getName()) {
      case 'carRegistration':
        return messages.car_registration;
    }

    return '?';
  };

  render() {
    const { intl: {messages}, entity, entityLoaded, appIntl } = this.props;
    const columns = [messages.image, messages.item, messages.price, messages.salesDoc.quantity];
    let tBody = [];
    let itemSumNet = 0;
    if (entityLoaded) {
      _forEach (entity.getItems(), (item, i) => {
        const thumbFile = getThumbFileFromEntity(item.img);

        itemSumNet += item.getNetPrice() * item.getQuantity();

        let tempVariantAttributes = [];
        if (item.getVariant()) {
          const attributes = item.getVariant().getAttributes();
          if (attributes && attributes.length > 0) {
            _forEach (attributes, (attribute, k) => {
              const attributeNames = attribute.getName();
              const attributeValues = attribute.getValues();
              if (attributeNames && attributeValues && attributeNames.length <= attributeValues.length) {
                _forEach (attributeNames, (attributeName, l) => {
                  const name = attributeName.getName();
                  const values = attributeValues[l].getValue();
                  if (name && values && values.length > 0) {
                    const value = values[0].getName();
                    if (value) {
                      tempVariantAttributes.push(name + ": " + value);
                    }
                  }
                });
              }
            });
          }
        }

        let itemName;
        (typeof item.getName() === 'object') ? itemName = getNameInCurrentLanguage(item.getName(), appIntl) : itemName = item.getName();
        let htmlItem = Math.min(1, item.getQuantity()) + " x " + itemName;
        let htmlDescription = item.getDescription() ? item.getDescription() : "";
        if (entity.getShipping() && entity.getShipping().length >0) {
          htmlDescription += ((htmlDescription.length > 0) ? ", " : "") + (messages.delivery_time + ": " + entity.getShipping());
        }
        if (tempVariantAttributes.length > 0) {
          htmlDescription += ((htmlDescription.length > 0) ? ", " : "" ) + tempVariantAttributes.join(", ");
        }

        tBody.push(
          <tr key={i}>
            <td class="v-align-middle">
              {thumbFile ? <img src={thumbFile.getWebLink()} style={{ width: '100px' }} /> : null}
            </td>
            <td class="v-align-middle">
              <div dangerouslySetInnerHTML={{__html: htmlItem       }} />

              {item.getDescription() ? <br /> : null}
              {item.getDescription() ? <span class="hint-text"><div dangerouslySetInnerHTML={{__html: htmlDescription}} /></span> : null}
            </td>
            <td class="v-align-middle">
              <FormattedNumber value={item.getGrossPrice()} style="currency" currency={entity.getCurrency()} />
            </td>
            <td class="v-align-middle text-right">{item.getQuantity()}</td>
          </tr>
        );
      });

      entity.getServices().map((service, i) => {
        if (service.getPrice() > 0) {
          tBody.push(
            <tr key={'service' + i}>
              <td class="v-align-middle"></td>
              <td class="v-align-middle">{this.getServiceName(service)}</td>
              <td class="v-align-middle">
                <FormattedNumber value={service.getPrice()} style="currency" currency={entity.getCurrency()} />
              </td>
              <td class="v-align-middle text-right">1</td>
            </tr>
          );
        }
      });

      if (entity.getShippingCost() > 0) {
        let shippingName = messages.shipping_pickup;
        switch (entity.getShipping()) {
          case 'transport':
            shippingName = messages.shipping_transport;
            break;

          case 'parcel':
            shippingName = messages.shipping_parcel;
            break;
        }

        tBody.push(
          <tr key={'shipping'}>
            <td class="v-align-middle"></td>
            <td class="v-align-middle">{shippingName}</td>
            <td class="v-align-middle">
              <FormattedNumber value={entity.getShippingCost()} style="currency" currency={entity.getCurrency()} />
            </td>
            <td class="v-align-middle text-right">1</td>
          </tr>
        );
      }
    }

    return entityLoaded ? (
      <div class="clearfix padding-20 sm-padding-10">
        <Grid fluid>
          <Row>
            <Col xs={12} md={8}>
              <Table responsive>
                <thead>
                  <tr>
                    {columns.map((column, i) => {
                      return (
                        <th key={i} class={column == messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>

              <Col class="no-padding m-t-15 text-right" xs={12} md={6} mdOffset={6}>
                <div class="font-secondary fs-12 all-caps m-b-10">{messages.salesDoc.order_totals}</div>
                <dl class="no-margin">
                  <dt>{messages.salesDoc.subtotal}</dt>
                  <dd>
                    <FormattedNumber value={itemSumNet} style="currency" currency={entity.getCurrency()} />
                  </dd>

                  {entity.getServices().map((service, i) => {
                    if (service.getPrice() > 0) {
                      let res = [];
                      let priceNet = service.getPrice() / (1 + 19 / 100);

                      res.push(
                        <dt class="m-t-5" key={'dt' + i}>
                          {this.getServiceName(service)}
                        </dt>
                      );
                      res.push(
                        <dd key={'dd' + i}>
                          <FormattedNumber value={priceNet} style="currency" currency={entity.getCurrency()} />
                        </dd>
                      );

                      return res;
                    }
                  })}

                  <dt class="m-t-5">{messages.promotions}</dt>
                  <dd>
                    <FormattedNumber
                      value={(entity.getSumDiscount() / (1 + 19 / 100)) * -1}
                      style="currency"
                      currency={entity.getCurrency()}
                    />
                  </dd>

                  {entity.getVatSumRates().map((vatSumRate, i) => {
                    let res = [];

                    res.push(
                      <dt class="m-t-5" key={'dt' + i}>
                        {vatSumRate.getRate()}%
                      </dt>
                    );
                    res.push(
                      <dd key={'dd' + i}>
                        <FormattedNumber value={vatSumRate.getSum()} style="currency" currency={entity.getCurrency()} />
                      </dd>
                    );

                    return res;
                  })}

                  <dt class="m-t-5">
                    <h5>{messages.salesDoc.total_due}</h5>
                  </dt>
                  <dd>
                    <h5 class="sm-m-t-0">
                      <FormattedNumber value={entity.getSumGross()} style="currency" currency={entity.getCurrency()} />
                    </h5>
                  </dd>
                </dl>
              </Col>
            </Col>
            <Col xsHidden smHidden md={4}>
              <div class="font-secondary fs-12 all-caps m-b-10">{messages.timeline}</div>

              <OrderTimelineContent entity={entity} />
            </Col>
          </Row>
        </Grid>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OrderInfo)));






